import {ChoiceList, ChoiceRow, ModalShell} from './ui/ModalShell';

export const BrokerDownloadOptionsModal = ({onSelect}) => (
  <ModalShell
    title="Broker download"
    subtitle="Choose the broker data to download as a CSV.">
    <ChoiceList>
      <ChoiceRow
        label="Broker Statement"
        description="Statement rows for a broker over a date range, formal or informal."
        onClick={() => onSelect('STATEMENT')}
      />
      <ChoiceRow
        label="Broker History"
        description="History rows for a broker over a date range."
        onClick={() => onSelect('HISTORY')}
      />
    </ChoiceList>
  </ModalShell>
);
